"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = lockerSlotsToLayoutTowers;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _constants = require("./constants");
function lockerSlotsToLayoutTowers(_ref) {
  var _ref2;
  var _ref$frontSideGaps = _ref.frontSideGaps,
    frontSideGaps = _ref$frontSideGaps === void 0 ? {} : _ref$frontSideGaps,
    _ref$frontSideTowerWi = _ref.frontSideTowerWidths,
    frontSideTowerWidths = _ref$frontSideTowerWi === void 0 ? {} : _ref$frontSideTowerWi,
    _ref$openedIpIoPairs = _ref.openedIpIoPairs,
    openedIpIoPairs = _ref$openedIpIoPairs === void 0 ? [] : _ref$openedIpIoPairs,
    slots = _ref.slots,
    slotTypeInfo = _ref.slotTypeInfo;
  var lockerHasTwoSides = slots.some(function (slot) {
    return Object.keys(slot.locks).includes(_constants.APM_SIDES.BACK);
  });
  var towerIds = (0, _toConsumableArray2.default)(new Set((_ref2 = []).concat.apply(_ref2, (0, _toConsumableArray2.default)(slots.map(function (item) {
    return Object.values(item.locks).map(function (lock) {
      return lock.towerId;
    });
  }))))).sort(function (a, b) {
    return a - b;
  });
  return towerIds.reduce(function (layoutTowers, towerId, i) {
    var isDropboxModule = false;
    [_constants.APM_SIDES.FRONT, _constants.APM_SIDES.BACK].forEach(function (side) {
      var _frontSideGaps$frontS, _frontSideGaps$frontS2, _slotTypeInfo$slots$f, _slots$find;
      var frontSideTowerId = side === _constants.APM_SIDES.FRONT ? towerId : towerIds[towerIds.length - 1 - i];
      var gaps = side === _constants.APM_SIDES.FRONT ? (0, _extends2.default)({}, frontSideGaps[frontSideTowerId]) : {
        left: (_frontSideGaps$frontS = frontSideGaps[frontSideTowerId]) == null ? void 0 : _frontSideGaps$frontS.right,
        right: (_frontSideGaps$frontS2 = frontSideGaps[frontSideTowerId]) == null ? void 0 : _frontSideGaps$frontS2.left
      };
      var towerWidth = frontSideTowerWidths[String(frontSideTowerId)] || (// default to width of the first slot if no towerWidth
      (_slotTypeInfo$slots$f = slotTypeInfo[(_slots$find = slots.find(function (slot) {
        var _slot$locks$side;
        return ((_slot$locks$side = slot.locks[side]) == null ? void 0 : _slot$locks$side.towerId) === towerId;
      })) == null ? void 0 : _slots$find.type]) == null ? void 0 : _slotTypeInfo$slots$f.displayWidth);
      var topPointer = 0;
      var leftPointer = 0;
      var consoleSlots = [];
      var towerSlots = [];
      slots.filter(function (slot) {
        return Object.entries(slot.locks).some(function (_ref3) {
          var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
            lockId = _ref4[0],
            lockProps = _ref4[1];
          return (0, _constants.isSideLock)(lockId, side) && lockProps.towerId === towerId;
        });
      }).sort(function (a, b) {
        return a.locks[side].seqNr - b.locks[side].seqNr;
      }).map(function (slot) {
        var _slot$orderIds;
        var locksOnSide = Object.entries(slot.locks).reduce(function (locks, _ref5) {
          var _ref6 = (0, _slicedToArray2.default)(_ref5, 2),
            lockId = _ref6[0],
            lockProps = _ref6[1];
          return (0, _constants.isSideLock)(lockId, side) ? [].concat((0, _toConsumableArray2.default)(locks), [lockProps]) : locks;
        }, []);
        var hasConsoleLock = locksOnSide.some(function (lock) {
          return lock.console;
        });
        var _ref7 = slotTypeInfo[slot.type] || {},
          displayHeight = _ref7.displayHeight,
          displayWidth = _ref7.displayWidth,
          dropbox = _ref7.dropbox,
          storable = _ref7.storable;
        isDropboxModule = dropbox;
        var slotRecord = (0, _extends2.default)({}, slot, {
          displayHeight,
          displayWidth,
          filled: slot.full || (slot == null ? void 0 : (_slot$orderIds = slot.orderIds) == null ? void 0 : _slot$orderIds.length),
          height: slot.height,
          left: leftPointer,
          open: locksOnSide.some(function (lock) {
            return lock.opened || openedIpIoPairs.some(function (_ref8) {
              var ip = _ref8.ip,
                io = _ref8.io;
              return ip === lock.ip && io === lock.io;
            });
          }),
          slotId: slot.id,
          slotTitle: locksOnSide.map(function (lock) {
            return "(".concat(Number.isInteger(lock.ip) ? lock.ip : '-', ", ").concat(Number.isInteger(lock.io) ? lock.io : '-', ")");
          }).join(', '),
          stateId: slot.status,
          top: topPointer
        });
        if (hasConsoleLock && storable === false) {
          slotRecord.type = 'Console';
          slotRecord.typeName = '';
          consoleSlots.push(slotRecord);
        } else {
          towerSlots.push(slotRecord);
        }
        topPointer = Number.MAX_SAFE_INTEGER;
        leftPointer = 0;

        // calculate lowest drawing point from top-left
        var _loop = function _loop(leftScanner) {
          var pointHeight = [].concat(consoleSlots, towerSlots) // slots that go through that point
          .filter(function (ts) {
            return leftScanner >= ts.left && leftScanner <= ts.left + ts.displayWidth;
          })
          // calculate point height over all passing slots
          .reduce(function (heightSum, curTs) {
            return heightSum + curTs.displayHeight;
          }, 0);
          if (pointHeight < topPointer && pointHeight !== topPointer) {
            leftPointer = Math.max(0, leftScanner - 0.2);
            topPointer = pointHeight;
          }
        };
        for (var leftScanner = 0; leftScanner < towerWidth - 1; leftScanner += 0.2) {
          _loop(leftScanner);
        }
        return slotRecord;
      });
      if (lockerHasTwoSides || consoleSlots.length || towerSlots.length) {
        // fill also playholder towers when other side has only one tower
        layoutTowers.push({
          consoles: consoleSlots,
          displayHeight: topPointer,
          displayWidth: towerWidth,
          gaps,
          id: towerId,
          side,
          slots: towerSlots,
          title: String(towerId),
          verticalAlign: isDropboxModule ? 'bottom' : 'top'
        });
      }
    });
    return layoutTowers;
  }, []);
}